import { useEffect } from 'react';
import SEO from '../components/SEO';
import { TRACKING_API_URL } from '../config';

export default function Purchase() {
  useEffect(() => {
    // Track Purchase event
    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_name: 'Purchase',
        custom_data: {
          currency: 'BRL',
          value: 49.99, // Replace with actual value
        },
      }),
    })
      .then(() => console.log('Purchase event tracked'))
      .catch((error) => console.error('Error tracking Purchase event:', error));

    console.log('teste')
    // Redirect after 1 second
    const timer = setTimeout(() => {
      window.location.href = 'https://plataforma.lawx.ai/dashboard';
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Compra Realizada"
        description="Sua compra foi realizada com sucesso. Redirecionando para a plataforma LawX..."
        url="/purchase"
        noindex={true}
        nofollow={true}
      />
    </div>
  );
} 